import { useEffect, useState, useCallback } from 'react';
import Loader from '../../../components/Loader'
import { toast } from "react-toastify";
import { uwinAPI } from "../../../services/uwin.api";
import CryptoJS from "crypto-js";
import RoutineVaccinationSection from './routineVaccination/RoutineVaccinationSection';
import { decryptOpenSSLAES } from "./uwin-decrypt";

export const Linkedchildren = ({ onClose, childProfileData, setShowUpdateHbValue, setProfileData, setHBTestingDate, HBTestingDate, benProfileData }) => {
    const [isPageLoading, setIsPageLoading] = useState(false);
    const [vaccinations, setVaccinations] = useState([]);
    const [activeBeneficiaryId, setActiveBeneficiaryId] = useState(null);
    const [vaccinationCache, setVaccinationCache] = useState({});
    
    const formatDobWithAge = useCallback((dobInput) => {
        const dob = new Date(dobInput);
        if (isNaN(dob)) return 'Invalid DOB';

        const today = new Date();

        let years = today.getFullYear() - dob.getFullYear();
        let months = today.getMonth() - dob.getMonth();
        let days = today.getDate() - dob.getDate();

        // Adjust days
        if (days < 0) {
            months -= 1;
            const previousMonth = new Date(today.getFullYear(), today.getMonth(), 0);
            days += previousMonth.getDate();
        }

        // Adjust months
        if (months < 0) {
            years -= 1;
            months += 12;
        }

        const formattedDate = dob.toLocaleDateString('en-GB'); // DD/MM/YYYY

        return `${years}y ${months}m ${days}d (${formattedDate})`;
    }, []);

    const handleOpenUpdateHB = (profileData) => {
        setShowUpdateHbValue(true);
        setProfileData(profileData);
    }

    const handleComingSoon = () => {
        toast.info("Feature coming soon!");
    };

    const encryptText = async (plaintext) => {
        try {
            const payload = {
                plaintext: plaintext
            }
            // Fetch the parent profile data
            const resEncrypt = await uwinAPI.encryptText(payload);
            return resEncrypt.data.encrypted;
        } catch (error) {
            console.error("Backend login error:", error);
        }
    };

    const getVaccinationData = async (beneficiary_reference_id) => {

        // Agar already data aa chuka hai to dobara API call mat karo
        if (vaccinationCache[beneficiary_reference_id]) {
            setVaccinations(vaccinationCache[beneficiary_reference_id]);
            return;
        }

        setIsPageLoading(true);

        try {
            const payload = {
                beneficiary_ref_id: await encryptText(beneficiary_reference_id)
            };

            const vaccineResponse = await uwinAPI.getVaccinations(payload);

            if (vaccineResponse.success) {
                setVaccinationCache(prev => ({
                    ...prev,
                    [beneficiary_reference_id]: vaccineResponse.data
                }));

                setVaccinations(vaccineResponse.data);
            } else {
                toast.error("No vaccination data found");
            }
        } catch (error) {
            toast.error("Error fetching vaccination data");
        } finally {
            setIsPageLoading(false);
        }
    };

    const handleAccordionOpen = (beneficiaryId) => {
        if (activeBeneficiaryId === beneficiaryId) {
            setActiveBeneficiaryId(null); // close
            return;
        }

        setActiveBeneficiaryId(beneficiaryId);
        getVaccinationData(beneficiaryId);
    };

    const isTestingDateOlderThan30Days = (testingDate) => {
        if (!testingDate) return false;

        const today = new Date();
        const testDate = new Date(testingDate);

        if (isNaN(testDate)) return false;

        const diffTime = today.getTime() - testDate.getTime();
        const diffDays = diffTime / (1000 * 60 * 60 * 24);
        return diffDays >= 30;
    };

    const handleChildVaccinationSaved = async (childRefId) => {
        setVaccinationCache((prev) => {
            const updated = { ...prev };
            delete updated[childRefId];
            return updated;
        });

        if (activeBeneficiaryId === childRefId) {
            await getVaccinationData(childRefId);
        }
    };

    return (
        <>
            {isPageLoading && <Loader />}
            {childProfileData?.map((child, index) => (
                <div className='sickleMedicationSection' key={child.beneficiary_reference_id}>
                    <div className=" mt-4">

                        <div className="accordion" id="LinkedChildrenAccordion">
                            <div className="patientDetailsTitleHeader-h d-flex mb-0">
                                <div className="leftHeaderBar">
                                    <h4> <span>
                                        <img
                                            src={"/images/uwin.svg"}
                                            alt=""
                                            style={{ width: "55px", margin: "10px" }}
                                        />
                                    </span> U-WIN Linked Children</h4>
                                </div>
                                <div className="closeDive close-uwin" onClick={() => onClose('handleCloseLinkChildren')}><img src={"/images/closing.svg"} alt="Close" /></div>
                            </div>

                            <section className='background-white-bg'>
                                <div className='d-flex profile_chiled'>
                                    <span className='button_right'>
                                        {/* Update Hb Value - hidden/disabled
                                        {isTestingDateOlderThan30Days(child?.hb_testing_date) && (
                                            <button className='mx-2 sickle-save-button' onClick={() => handleOpenUpdateHB(child)} >Update Hb Value</button>
                                        )}
                                        */}
                                        {/* {!child?.abha_number && (
                                            <button className='sickle-save-button' onClick={() => handleComingSoon()}>Link ABHA</button>
                                        )} */}
                                    </span>
                                </div>
                                <div className='d-flex profile_chiled pregnent_women'>
                                    <img src={"/images/user.png"} alt="Child" className='mx-2' />
                                    <p>{child?.ben_name}</p>
                                    <p><span className='boreder_right'> {child?.ben_mobile_number} </span> <span className='boreder_right'> {formatDobWithAge(child?.dob)} </span></p>
                                </div>
                                <div className='d-flex profile_chiled pregnent_women'>
                                    <p> <span> {child?.beneficiary_gender} </span>  <span className='boreder_right'> {child?.beneficiary_type_name}</span></p>
                                </div>

                                <div className='d-flex'>
                                    <> </>
                                    {(child?.beneficiary_id_type_name && child?.photo_id_number) && (
                                        <>
                                            <div className='profile_chiled mt-3'>
                                                <p>IDENTIFICATION</p>
                                                <p><span> {decryptOpenSSLAES(child?.beneficiary_id_type_name)} </span> <span className='boreder_right'>{decryptOpenSSLAES(child?.photo_id_number)}</span></p>
                                            </div>
                                        </>
                                    )}
                                </div>
                            </section>

                            {/* Accordion 1 */}
                            <div className="accordion-item">
                                <h2 className="accordion-header" id="headingOne">
                                    <button className="accordion-button fw-bold margin-accordian-btn collapsed" type="button" data-bs-toggle="collapse" data-bs-target={`#collapse-${child.beneficiary_reference_id}`} onClick={() => handleAccordionOpen(child.beneficiary_reference_id)} >
                                        <span>Routine Vaccination</span>
                                    </button>
                                </h2>
                                <div id={`collapse-${child.beneficiary_reference_id}`} className={`accordion-collapse collapse ${activeBeneficiaryId === child.beneficiary_reference_id ? "show" : ""}`} data-bs-parent="#LinkedChildrenAccordion" >
                                    {activeBeneficiaryId === child.beneficiary_reference_id && (
                                        <div className="accordion-body">
                                            <RoutineVaccinationSection
                                                beneficiaryRow={child}
                                                beneficiaryType="CHILD"
                                                sessionSiteId={benProfileData?.session_site_id}
                                                vaccinationDetails={
                                                    vaccinationCache[child.beneficiary_reference_id]?.vaccinationDetails
                                                }
                                                onVaccinationSaved={() =>
                                                    handleChildVaccinationSaved(child.beneficiary_reference_id)
                                                }
                                            />
                                        </div>
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            ))}
        </>
    )
}
